<ag-shr-modal-window
  #mergeAlertModalRef
  [title]="'Alert'"
  [width]="'320px'"
  [height]="'auto'"
  [useScrollView]="false"
  [showSaveButton]="false"
  [showCancelButton]="true"
  [cancelTitle]="'Ok'"
  [customClass]="'merge-in-progress-alert-modal__popup'"
  [onCloseModal]="onModalHiding"
>
  <div class="merge-in-progress-alert-modal__message">
    This Agent Record is in merge process and cannot be edited until it's finished.
  </div>
</ag-shr-modal-window>
